import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { IFormGroup, IFormItem } from '@d-components/dynamic-form/form-base';

@Injectable()
export class FormService {
  constructor() {}

  toFormGroup(formItems: IFormItem[], initialForm?: FormGroup) {
    const group: any = {};

    formItems.forEach((formItem) => {
      const validators = formItem.validators || [];

      // TODO: should not use empty string as default form control value
      group[formItem.key] = new FormControl(
        {
          value: initialForm?.get(formItem.key)?.value ?? formItem.value ?? '',
          disabled: formItem.disabled,
        },
        Validators.compose(validators),
      );
    });

    return new FormGroup(group);
  }

  toFormGroupList(groups: IFormGroup[]) {
    const group: any = {};

    groups.forEach((g) => {
      group[g.key] = this.toFormGroup(g.items);
    });

    return new FormGroup(group);
  }
}
